import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Assignment from '../components/courses/Assignment'

const AssignmentPage = () => {
  return (
   <>
    <Navbar/>
    <Assignment/>
   </>
  )
}

export default AssignmentPage